import {appInsights} from '../app-insights';

const EVENT_LOGIN_PAYMENT_STATUS = 'LOGIN_TO_PAY';

export const logLoginPaymentStatusEvent = ({checkoutSessionId, paymentStatus, customerId}: PaymentStatusEvent) => {
  appInsights.trackEvent({
    name: EVENT_LOGIN_PAYMENT_STATUS,
    properties: {
      paymentStatus,
      customerId,
      checkoutSessionId,
    },
  });
};
